import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { ParentSize } from '@visx/responsive';
import StackedDateChart from './StackedDateChart';
import useBins from '../hooks/useBins';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
}));

const SingleColumnLayout = ({ sortedOpenBins }) => {
  return (
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs="auto" style={{ width: 640, maxWidth: 640 }} zeroMinWidth>
        <Grid container justifyContent="center">
          <ParentSize>
            {({ width }) => (
              <StackedDateChart
                width={width}
                height={300}
                bins={sortedOpenBins}
              />
            )}
          </ParentSize>
        </Grid>
      </Grid>
    </Grid>
  );
};

SingleColumnLayout.defaultProps = {
  sortedOpenBins: [],
};

SingleColumnLayout.propTypes = {
  sortedOpenBins: PropTypes.array,
};

const DoubleColumnLayout = ({
  sortedClosedFilledBins,
  sortedApplicantsInterviesOffersBins,
}) => {
  return (
    <Grid container spacing={8} justifyContent="center">
      <Grid item xs="auto" style={{ width: 640, maxWidth: 640 }} zeroMinWidth>
        <Grid container justifyContent="center">
          <ParentSize>
            {({ width }) => (
              <StackedDateChart
                width={width}
                height={300}
                bins={sortedClosedFilledBins}
              />
            )}
          </ParentSize>
        </Grid>
      </Grid>
      <Grid item xs="auto" style={{ width: 640, maxWidth: 640 }} zeroMinWidth>
        <Grid container justifyContent="center">
          <ParentSize>
            {({ width }) => (
              <StackedDateChart
                width={width}
                height={300}
                bins={sortedApplicantsInterviesOffersBins}
              />
            )}
          </ParentSize>
        </Grid>
      </Grid>
    </Grid>
  );
};

DoubleColumnLayout.defaultProps = {
  sortedClosedFilledBins: [],
  sortedApplicantsInterviesOffersBins: [],
};

DoubleColumnLayout.propTypes = {
  sortedClosedFilledBins: PropTypes.array,
  sortedApplicantsInterviesOffersBins: PropTypes.array,
};

const Charts = ({ openJobs, closedJobs }) => {
  const classes = useStyles();
  const {
    sortedOpenBins,
    sortedClosedFilledBins,
    sortedApplicantsInterviesOffersBins,
  } = useBins({ openJobs, closedJobs });

  return (
    <Container className={classes.root}>
      {openJobs.length ? (
        <SingleColumnLayout sortedOpenBins={sortedOpenBins} />
      ) : (
        <DoubleColumnLayout
          sortedClosedFilledBins={sortedClosedFilledBins}
          sortedApplicantsInterviesOffersBins={
            sortedApplicantsInterviesOffersBins
          }
        />
      )}
    </Container>
  );
};

Charts.defaultProps = {
  openJobs: [],
  closedJobs: [],
};

Charts.propTypes = {
  openJobs: PropTypes.array,
  closedJobs: PropTypes.array,
};

export default Charts;
